<template>
  <div class="label-data-title">
    <span class="label-data-title-label">{{ label }}: </span>

    <span
      v-if="data"
      class="label-data-title-data"
    >{{ data }}</span>
  </div>
</template>

<script>
export default {
  name: 'LabelDataTitle',
  props: {
    label: {
      type: String,
      required: true
    },
    data: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@use '@/../static/stylesheets/variables' as *;

.label-data-title {
  font-size: 1.375rem;

  &-label {
    color: $label-color;
  }

  &-data {
    color: $theme-primary-color;
  }
}
</style>
